import * as React from 'react';

import { I18nextProvider, initReactI18next } from 'react-i18next';
import { extractTranslationsFromJson, getLang, getTitle } from 'utils';

import Backend from 'i18next-http-backend';
import { Lang } from 'enums';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Loader } from 'components';
import i18n from 'i18next';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

type I18nProviderProps = {};

export const I18nProvider: React.FC<React.PropsWithChildren<I18nProviderProps>> = observer(({ children, ...rest }) => {
  const { appStore } = useStores();

  const options = {
    order: ['navigator'],
  };

  React.useEffect(() => {
    document.title = getTitle(appStore.lang);

    i18n
      .use(Backend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        keySeparator: false,
        nsSeparator: false,
        returnObjects: true,
        detection: options,
        fallbackLng: Lang.UK,
        interpolation: {
          escapeValue: false, // react already safes from xss
        },
        backend: {
          loadPath: process.env.REACT_APP_BUNDLE_URL,
          parse: extractTranslationsFromJson(appStore.lang),
        },
        debug: false,
      })
      .then(() => {
        appStore.setLang(getLang(i18n.language));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appStore.lang]);

  return (
    <React.Suspense fallback={<Loader />}>
      <I18nextProvider i18n={i18n} {...rest}>
        {children}
      </I18nextProvider>
    </React.Suspense>
  );
});
